import { SvgIcon } from '@mui/material';
import React from 'react'
export const PresentationIcon = (props) => {
    return <SvgIcon {...props} width="24" height="24" viewBox="0 0 18 16" fill="none">
           <path d="M18 1.57143V0H16.1129H14.5161H3.48387H1.8871H0V1.57143H1.8871V9V10.5714H3.48387H8.27419V12.4286L5.80645 14.8571L6.96774 16L9.14516 13.8571L11.3226 16L12.4839 14.8571L9.72581 12.4286V10.5714H14.5161H16.1129V9V1.57143H18ZM14.5161 9H9.72581H8.27419H3.48387V1.57143H14.5161V9Z" fill={props.style?.color} />
    </SvgIcon>
}